export default __webpack_public_path__ + "static/media/github-.b1997d6c.svg";